/** The task-bank and generation problem codes an API error's body carries in `code` (QZ-D42). */
export const PROBLEM_CODES = {
  TaskNotFound: 'TaskNotFound',
  InvalidTask: 'InvalidTask',
  UnknownTag: 'UnknownTag',
  TaskNotDraft: 'TaskNotDraft',
  TransitionNotAllowed: 'TransitionNotAllowed',
  TaskChanged: 'TaskChanged',
  InvalidTagName: 'InvalidTagName',
  TagExists: 'TagExists',
  JobNotFound: 'JobNotFound',
  JobEnded: 'JobEnded',
  NoSources: 'NoSources',
  UnknownSource: 'UnknownSource',
  InvalidDomain: 'InvalidDomain',
  SourceExists: 'SourceExists',
  SourceNotFound: 'SourceNotFound',
  LastSource: 'LastSource',
  TooManySources: 'TooManySources',
  InvalidMaterial: 'InvalidMaterial',
  MaterialExpired: 'MaterialExpired',
  ExtractionNotFound: 'ExtractionNotFound',
  MaterialTooLarge: 'MaterialTooLarge',
  InvalidPageRange: 'InvalidPageRange',
  JobNotEnded: 'JobNotEnded',
  SourceReferenceLocked: 'SourceReferenceLocked',
} as const;
export type ProblemCode = keyof typeof PROBLEM_CODES;
